var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-btn ui-btn-share",on:{"click":_vm.handleClick}},[_c('i',{staticClass:"icon-share"}),_c('span',[_vm._v("分享作品")])])}
var staticRenderFns = []

export { render, staticRenderFns }